/**
 * @generated SignedSource<<9d0e7559dd7169ebfdfce4619c330889>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutDeliveryOptions_buyer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"BuyerShipmentRequest_buyer" | "CheckoutAllowCustomQuote_buyer">;
  readonly " $fragmentType": "CheckoutDeliveryOptions_buyer";
};
export type CheckoutDeliveryOptions_buyer$key = {
  readonly " $data"?: CheckoutDeliveryOptions_buyer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutDeliveryOptions_buyer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutDeliveryOptions_buyer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BuyerShipmentRequest_buyer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutAllowCustomQuote_buyer"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "6fa5d2712a2ddb1e79c20680bf2ca7d6";

export default node;
